import SignalController from './index';
import { uuid } from '../utils';
import { preferCodecs } from '../preferCodecs';

export default class TencentSignalController extends SignalController {
  private baseUrl = 'https://overseas-webrtc.liveplay.myqcloud.com';
  private svrSig = null;

  async fetchStreamAnswer(offer: RTCSessionDescriptionInit, playUrl: string): Promise<RTCSessionDescriptionInit> {
    const fetchPullStream = async (baseUrl: string, data) => {
      const resp = await this.callAPI<{ errcode: number; errmsg: string; remotesdp: { sdp: string; type: 'answer' }; svrsig: string }>(
        baseUrl + '/webrtc/v1/pullstream',
        data,
      );

      const { errcode, errmsg, remotesdp, svrsig } = resp;
      if (errcode !== 0) {
        throw new Error(`errCode: ${errcode}, errMsg: ${errmsg}`);
      }

      return {
        url: baseUrl,
        remoteSdp: remotesdp,
        svrSig: svrsig,
      };
    };

    try {
      let resp = null;
      const data = {
        streamurl: playUrl,
        sessionid: uuid(),
        clientinfo: null,
        localsdp: offer,
      };
      if (this.baseUrl) {
        resp = await fetchPullStream(this.baseUrl, data);
      } else {
        const promises = ['overseas-webrtc.liveplay.myqcloud.com', 'oswebrtc-lint.liveplay.myqcloud.com'].map((domain) => {
          return fetchPullStream(`https://${domain}`, data);
        });
        resp = await Promise.any(promises);
        this.baseUrl = resp.url;
      }

      this.svrSig = resp.svrSig;
      return resp.remoteSdp;
    } catch (err) {
      throw err?.errors?.[0] || err;
    }
  }

  fetchStreamSdp(offer: RTCSessionDescriptionInit, url: string): Promise<RTCSessionDescriptionInit> {
    return Promise.resolve(undefined);
  }

  async fetchStopStream(playUrl: string) {
    if (!this.baseUrl) {
      throw new Error('signal domain name is empty');
    }
    if (!this.svrSig) {
      return;
    }
    const { errcode, errmsg } = await this.callAPI(this.baseUrl + '/webrtc/v1/stopstream', {
      streamurl: playUrl,
      svrsig: this.svrSig,
    });

    if (errcode !== 0) {
      throw new Error(`stop stream failed, errCode: ${errcode}, errMsg: ${errmsg}`);
    }

    this.svrSig = null;
  }

  public override sdpTransform(sdp: string): string {
    return preferCodecs(sdp);
  }

  private async callAPI<T = any>(_url: string, data) {
    if (this.abortController) {
      this.abortController.abort('recreate');
    }
    this.abortController = new self.AbortController();

    if (this.fetchTimeout !== Infinity && this.fetchTimeout > 0) {
      this.timerId = setTimeout(() => {
        this.abort('timeout');
      }, this.fetchTimeout);
    }

    try {
      const { url, options } = this.fetchSetup(_url, {
        body: JSON.stringify(data),
        cache: 'no-cache',
        credentials: 'same-origin',
        signal: this.abortController.signal,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        mode: 'cors',
      });

      const resp = await fetch(url, options);

      if (resp.status !== 200) {
        throw new Error(`status code: ${resp.status}`);
      }

      return await resp.json() as T;
    } finally {
      this.clearTimeout();
      this.abortController = null;
    }
  }
}
